import { Image } from 'lucide-react'
import { Seo } from '@/components/seo'
import { PageLayout } from '@/components/layout/page-layout'
import { ToolPageLayout } from '@/components/tools/tool-page-layout'
import { ImagePanel } from '@/features/image/image-panel'
import { useI18n } from '@/lib/i18n'

export default function ImageCompressorPage() {
  const { t } = useI18n()

  return (
    <PageLayout>
      <Seo
        title={t('seoImageTitle')}
        description={t('seoImageDesc')}
        keywords={t('seoImageKw').split(',').map((item) => item.trim())}
      />
      <ToolPageLayout
        icon={Image}
        title={t('toolPageImage')}
        description={t('toolPageImageDesc')}
        formats={['JPG', 'PNG', 'WEBP']}
      >
        <ImagePanel />
      </ToolPageLayout>
    </PageLayout>
  )
}